/**
 * Enum correspondente aos tipo de parcelas acordo.
 */
export enum TipoParcelaAcordoEnum {

    ENTRADA                     = 1,
    DEMAIS_PARCELAS             = 2

}
